# Controla a visibilidade dos campos do cadastro de serviço conforme o "Tipo"
# selecionado (1º campo). Cada container condicional possui a classe
# `.js-service-type-field` e um atributo `data-show-for-types` com a lista de
# índices de service_type (separados por vírgula) em que deve aparecer.
export default class QuickRecordField
  @SELECT_SELECTOR: '#servico_servico_service_type'
  @FORM_SELECTOR: '#servico_form'
  @FIELD_SELECTOR: '.js-service-type-field'
  @CONTAINER_SELECTOR: '#quick-record-field-container'
  @CHECKBOX_SELECTOR: '#checkbox-quick-record-enabled'
  @PRELIMINAR_FIELD_SELECTOR: '.js-preliminar-only-field, .js-preliminar-weight-field'
  @UNIDADE_SELECT_SELECTOR: '#servico_servico_unidade_medida_id'
  @UNIDADE_HIDDEN_SELECTOR: '#js-preliminar-unidade-medida'
  @PRELIMINAR_VALUE: '3'

  @handler_events: ->
    @sync()

    $(document).off('change.quickRecord').on 'change.quickRecord', @SELECT_SELECTOR, =>
      @sync()

  @sync: ->
    select = $(@SELECT_SELECTOR)
    return unless select.length

    selected_type = String(select.val()).trim()

    # Mantém o tipo selecionado disponível para a tela de itens/métodos.
    $(@FORM_SELECTOR).attr('data-service-type', selected_type)

    # Lê o atributo cru (não `.data()`) para evitar coerção de tipo/cache do
    # jQuery e compara sempre como string normalizada.
    $(@FIELD_SELECTOR).each ->
      field = $(this)
      raw = field.attr('data-show-for-types')
      raw = '' unless raw?
      allowed = String(raw).split(',').map (value) -> value.trim()
      field.toggle(allowed.indexOf(selected_type) isnt -1)

    # Ficha Rápida: limpa o checkbox quando o container está oculto.
    quick_record_visible = $(@CONTAINER_SELECTOR).is(':visible')
    $(@CHECKBOX_SELECTOR).prop('checked', false) unless quick_record_visible

    # Campos de método exclusivos de Preliminar (peso + flag de aprovação).
    is_preliminar = selected_type is @PRELIMINAR_VALUE
    $(@PRELIMINAR_FIELD_SELECTOR).toggle(is_preliminar)

    @sync_unidade_medida(is_preliminar)

  # Preliminar usa sempre a unidade padrão do sistema: força a seleção,
  # desabilita o select para o usuário e envia o valor via campo oculto
  # (selects desabilitados não são submetidos no form).
  @sync_unidade_medida: (is_preliminar) ->
    select = $(@UNIDADE_SELECT_SELECTOR)
    hidden = $(@UNIDADE_HIDDEN_SELECTOR)
    return unless select.length

    default_unit_id = $(@FORM_SELECTOR).data('default-unit-id')
    default_unit_id = String(default_unit_id) if default_unit_id?
    has_default = default_unit_id? and default_unit_id isnt ''

    # Preliminar usa a unidade padrão e bloqueia a escolha do usuário — porém só
    # bloqueia quando há uma unidade padrão configurada. Sem padrão, mantém o
    # select habilitado para não impedir o cadastro (degradação graciosa).
    if is_preliminar and has_default
      select.val(default_unit_id).trigger('change.select2')
      hidden.val(default_unit_id)
      hidden.prop('disabled', false)
      select.prop('disabled', true).trigger('change.select2')
    else
      hidden.prop('disabled', true)
      select.prop('disabled', false).trigger('change.select2')
